import { render } from "./PostCommentContainer.vue?vue&type=template&id=a027a9ee&scoped=true"
import script from "./PostCommentContainer.vue?vue&type=script&lang=js"
export * from "./PostCommentContainer.vue?vue&type=script&lang=js"

import "./PostCommentContainer.vue?vue&type=style&index=0&id=a027a9ee&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a027a9ee"]])

export default __exports__